<template>
<div class="monitor">
  <box ref="box"></box>
  <div class="row clearfix" ref="card">
    <div class="col" @click="selectCol(1)">
      <el-card shadow="never" class="info-card-wrapper" :padding="0"  :class="{'activeFire': currentIndex === 1}">
        <infor-card :url="fire">
          <p class="count-style" :class="{'active': currentIndex === 1}">{{fireCount}}</p>
          <p class="name" :class="{'active': currentIndex === 1}">{{ $t('fire') }}</p>
        </infor-card>
      </el-card>
    </div>
    <div class="col" @click="selectCol(2)">
      <el-card shadow="never" class="info-card-wrapper" :padding="0" :class="{'activeFault': currentIndex === 2}">
      <infor-card :url="fault">
        <p class="count-style" :class="{'active': currentIndex === 2}">{{faultCount}}</p>
        <p class="name" :class="{'active': currentIndex === 2}">
          <span>{{ $t('fault') }}</span>
          <span>
            <el-switch
            @change="setFaultChange"
              v-model="faultReceive"
              active-text=""
              inactive-text="">
            </el-switch>
          </span>
        </p>
      </infor-card>
      </el-card>
    </div>
    <div class="col" @click="selectCol(3)">
      <el-card shadow="never" class="info-card-wrapper" :padding="0" :class="{'activeMonitor': currentIndex === 3}">
      <infor-card :url="monitor">
        <p class="count-style" :class="{'active': currentIndex === 3}">{{regularCount}}</p>
        <p class="name" :class="{'active': currentIndex === 3}">{{ $t('supervision') }}</p>
      </infor-card>
      </el-card>
    </div>
    <div class="col" @click="selectCol(4)">
      <el-card shadow="never" class="info-card-wrapper" :padding="0" :class="{'activeShield': currentIndex === 4}">
      <infor-card :url="shield">
        <p class="count-style" :class="{'active': currentIndex === 4}">{{shieldCount}}</p>
        <p class="name" :class="{'active': currentIndex === 4}">{{ $t('shield') }}</p>
      </infor-card>
      </el-card>
    </div>
    <div class="col" @click="selectCol(5)">
      <el-card shadow="never" class="info-card-wrapper" :padding="0" :class="{'activeFeedback': currentIndex === 5}"
               @click="selectCol(5)">
      <infor-card :url="feedback">
        <p class="count-style" :class="{'active': currentIndex === 5}">{{feedbackCount}}</p>
        <p class="name" :class="{'active': currentIndex === 5}">{{ $t('feedback') }}</p>
      </infor-card>
      </el-card>
    </div>
  </div>
  <el-card shadow="never" :style="style">
    <el-table ref="basePageTable" :data="rows_show" v-loading="searching">
      <el-table-column type="index" :label="$t('number')" :index="indexMethod" align="center"></el-table-column>
      <el-table-column prop="time" :label="$t('time')" align="center">
        <template slot-scope="scope">
          {{getTime(scope.row.time)}}
        </template>
      </el-table-column>
      <el-table-column prop="deviceType" :label="$t('equipmentType')" align="center">
        <template slot-scope="scope">
          {{deviceType[scope.row.deviceType]}}
        </template>
      </el-table-column>
      <el-table-column prop="address" :label="$t('address')" align="center">
        <template slot-scope="scope">
          {{
            scope.row.controllerNo +
            ( scope.row.loopNo ? ("-" + scope.row.loopNo) : "" ) +
            ( (scope.row.loopNo && scope.row.codeNo) ? ("-" + scope.row.codeNo) : "" ) +
            ( (scope.row.loopNo && scope.row.codeNo && scope.row.channelNo) ? ("." + scope.row.channelNo) : "" )
          }}
        </template>
      </el-table-column>
      <el-table-column prop="descr" :label="$t('annotation')" align="center"></el-table-column>
      <el-table-column prop="val" :label="$t('event')" align="center">
        <template slot-scope="scope">
          {{statType[scope.row.val]}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination  @current-change="handleCurrentChange" :current-page.sync="pageNumber" :total="total" :page-size="pageSize">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import Box from "@/components/Box";
import inforCard from "@/components/infor-card/infor-card";
import fire from "@/assets/img/monitor/fire.png"
import fault from "@/assets/img/monitor/fault.png"
import monitor from "@/assets/img/monitor/monitor.png"
import feedback from "@/assets/img/monitor/feedback.png"
import shield from "@/assets/img/monitor/shield.png"
import BasePage from "@/components/BasePage";
import { setFault } from "@/api/monitor.js"
export default {
  name: "monitor",
  components: {
    Box, inforCard
  },
  mixins: [BasePage],
  data() {
    return {
      fire,
      fault,
      monitor,
      feedback,
      shield,
      searching: false,
      style: null,
      currentIndex: 1, // 1: 火警  2:故障  3: 监管  4: 屏蔽  5: 联动反馈
      rows_show:[],
      indexToCode:{
        "1": "1",
        "2": "6",
        "3": "5",
        "4": "7",
        "5": "3,4"
      },
      pageNumber: 1,
      allData:[],
    }
  },
  mounted() {
    console.log(this.$store.state.monicentorList,'monicentorList')
    // this.calcHeight()
    this.getRows(this.currentIndex)
  },
  computed:{
    faultReceive:{
      get(){
        return this.$store.state.faultReceive
      },
      set(val){
        this.$store.commit("setfaultReceive",val)
      }
    },
    language(){
      return this.$store.state.language
    },
    statType(){
      let list = this.$store.state.statOptions
      return this.codeToName(list, "code", "name");
    },
    deviceType(){
      let list = this.$store.state.deviceTypeOptions
      return this.codeToName(list, "code", "name");
    },
    fireCount(){
      return this.$store.state.fireCount
    },
    faultCount(){
      return this.$store.state.faultCount
    },
    regularCount(){
      return this.$store.state.regularCount
    },
    shieldCount(){
      return this.$store.state.shieldCount
    },
    feedbackCount(){
      return this.$store.state.feedbackCount
    },
    controllInfo() {
      return this.$store.state.controlInfo
    },
  },
  methods: {
    handleCurrentChange(val){
      //
      console.log(val,"val")
      this.pageNumber = val;
      this.rows_show = this.deal_socket_data(this.$store.state.monicentorList, this.currentIndex)
    },
    codeToName(list, key, name){
      let res = {}
      list.forEach(v => {
        if (!res[v[key]]) {
          res[v[key]] = v[name];
        }
      })
      return res
    },
    /**
     * @param list
     * @param index
     * @description
     */
    deal_socket_data(list, index = 1){
      // debugger
      let i = String(index)
      // type:  1: 火警  6:故障  5: 监管  7: 屏蔽  3\4: 联动反馈
      // index: 1: 火警  2:故障  3: 监管  4: 屏蔽  5: 联动反馈
      this.allData = list.filter(v => {
        return this.indexToCode[i].includes(v.type)
      })
      this.total = this.allData.length;
      // console.log(this.allData)
      let copyallData = JSON.parse(JSON.stringify(this.allData))
      return this.dealPageData(copyallData)
    },
    dealPageData(list){
      return list.splice((this.pageNumber - 1) * this.pageSize, this.pageSize)
    },
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = (this.$refs.box.$el.clientHeight + this.$refs.card.$el.clientHeight + 14) + 'px'
        this.style = `height: calc(100vh - 168px - ${this.bottomHeight})`
      }, 20)
    },
    selectCol(index) {
      this.currentIndex = index;
      this.getRows(this.currentIndex)
    },
    getRows(index) {
      this.rows_show = this.deal_socket_data(this.$store.state.monicentorList, index)
    },
    setFaultChange(value){
      console.log(value,'----')
      setFault({controllerPsn: this.controllInfo.controllerPsn, fault: value}).then((res) => {
        console.log(res)
        this.$store.state.faultReceive = value;
        sessionStorage.faultReceive = value;
      }).catch(err => {
        console.log(err)
        this.$store.state.faultReceive = !value;
        sessionStorage.faultReceive = !value;
      })
    },
    getTime(timeStamp){
      let date = new Date(timeStamp * 1000)
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();
      let hh = date.getHours();
      let mf = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
    }
  },
  watch:{
    "$store.state.monicentorList" (newVal) {
      this.rows_show = this.deal_socket_data(newVal, this.currentIndex);
    },
  }
}
</script>

<style lang="scss" scoped>
.monitor{
  .card{
    width: 100%;
    display: inline-block;
    .cardInfo{
      width: 20%;
      display: inline-block;
    }
  }
  .row{
    margin-left: -5px;
    margin-right: -5px;
    margin-bottom: 10px;
    .col{
      width: 20%;
      padding-left: 5px;
      padding-right: 5px;
      box-sizing: border-box;
      float: left;
      .info-card-wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        &.activeFire {
          background-color: #FF3F19;
        }
        &.activeFault {
          background-color: #F7AB47;
        }
        &.activeMonitor {
          background-color: #00BEFF;
        }
        &.activeShield {
          background-color: #FB6041;
        }
        &.activeFeedback {
          background-color: #2DC555;
        }
        .count-style {
          color: #646464;
          font-size: 48px;
          margin: 0;
          line-height: 1;
          &.active{
            color: #ffffff;
          }
        }
        .name {
          font-size: 16px;
          color: #959595;
          margin: 0;
          :first-child{
            margin-right: 5px;
          }
          &.active{
            color: #ffffff;
          }
        }
      }
    }
  }
  .clearfix:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear:both;
    visibility: hidden;
  }
}
</style>
